import { render, staticRenderFns } from "./TransportationLocationUpdateModal.vue?vue&type=template&id=2915de12"
import script from "./TransportationLocationUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransportationLocationUpdateModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports